<script>
import StorageFee from "@/view/finances/other_fee/extra/StorageFee.vue";

export default {
  name: "ChargeModal",
  components: {StorageFee},
  data() {
    return {
      activeName: 'storageFee'
    }
  },
  props: {
    close: {
      type: Function,
      default: () => {}
    },
    refresh:{
      type: Function,
      default: () => {}
    }
  }
}
</script>

<template>
  <Tabs :value="activeName">
    <TabPane label="仓租费" name="storageFee">
      <StorageFee :close="close" :refresh="refresh" />
    </TabPane>
  </Tabs>
</template>

<style scoped>

</style>
